import { useMemo } from 'react';
import { useParams } from 'react-router';

export default function useResolveCurrentOrg() {
    const { organizationId, managedOrgId } = useParams<{ organizationId: string; managedOrgId: string }>();
    const currentOrgId = useMemo(() => {
        return managedOrgId || organizationId;
    }, [managedOrgId, organizationId]);

    return { organizationId: currentOrgId, parentOrgId: organizationId, managedOrgId };
}
